export enum Status {
  FINISHED = 'finished',
  SUCCESS = 'success',
  PENDING = 'pending',
  CHARGING = 'charging',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
}
